var React = require('react');

function Nop (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7.79136 0.208636C7.51318 -0.0695454 7.06216 -0.0695454 6.78398 0.208636L4.00012 2.9925L1.21661 0.208754L1.1283 0.133625C0.849873 -0.0667315 0.459353 -0.0417866 0.208835 0.208518C-0.0695193 0.486635 -0.069625 0.937656 0.208599 1.2159L2.99254 4.00008L0.208636 6.78398L0.133527 6.87227C-0.0667636 7.15064 -0.0417273 7.541 0.208636 7.79136C0.486818 8.06955 0.93784 8.06955 1.21602 7.79136L3.99988 5.0075L6.78339 7.79125L6.8717 7.86638C7.15013 8.06673 7.54065 8.04179 7.79117 7.79148C8.06952 7.51336 8.06962 7.06234 7.7914 6.7841L5.00746 3.99992L7.79136 1.21602L7.86647 1.12773C8.06676 0.849364 8.04173 0.459 7.79136 0.208636Z"}));
}

Nop.defaultProps = {"viewBox":"0 0 8 8","fill":"#ABBBCC"};

module.exports = Nop;

Nop.default = Nop;
